function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#F17071",
  width: 48,
  height: 48,
  rx: 24
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13 15)",
  stroke: "#FFF",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M.614.558L11 10 21.385.559"
}), /*#__PURE__*/React.createElement("rect", {
  strokeLinecap: "square",
  width: 22,
  height: 18,
  rx: 2
})));

function SvgContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDggNDgiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cmVjdCBmaWxsPSIjRjE3MDcxIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHJ4PSIyNCIgLz4KICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMyAxNSkiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPHBhdGggZD0iTS42MTQuNTU4TDExIDEwIDIxLjM4NS41NTkiIC8+CiAgICAgICAgICAgIDxyZWN0IHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHdpZHRoPSIyMiIgaGVpZ2h0PSIxOCIgcng9IjIiIC8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgContact as ReactComponent };